import axios from '@fs/zion-axios'
import { getPerson } from './personService'
import { mapSummaryToHistoricalFields } from '../util/TreeSummaryToHistoricalFields'

const BASE_FAMOUS_PATH = '/service/dmc/famous'

export function searchForPerson(params) {
  return axios.get(`${BASE_FAMOUS_PATH}/match-persons`, {
    params: { ...params },
  })
}

export function createPerson(personDto) {
  return axios.post(`${BASE_FAMOUS_PATH}/match-person`, personDto)
}

export function updatePerson(personDto) {
  return axios.put(`${BASE_FAMOUS_PATH}/match-persons/${personDto.id}`, personDto)
}

export function deletePerson(searchMatchId) {
  return axios.delete(`${BASE_FAMOUS_PATH}/match-persons/${searchMatchId}`)
}

export function getAllPersons(matchType) {
  return axios.get(`${BASE_FAMOUS_PATH}/match-persons/${matchType}/all`)
}

/**
 * Derives a historical person's tree-sourced fields from a Person ID, for review before saving.
 * Persists nothing; a merged PID is resolved to its survivor by `forward=true` (BR-16).
 *
 * Reads the console's own person summary and maps it here rather than calling the worker's
 * `/match-persons/pre-populate/{pid}`: that endpoint exists in famous-person-worker but has no
 * passthrough in data-dmconsole-server, so it 404s. Pre-populating is a view concern -- it persists
 * nothing and the ordinary create path does the saving -- so it does not need a route of its own.
 * The mapping rules are held identical to the worker's mapper; see TreeSummaryToHistoricalFields.
 */
export async function prePopulateHistoricalPerson(personId) {
  const summary = await getPerson(personId, true)
  if (!summary?.id) {
    throw new Error(`No Family Tree person for ${personId}`)
  }
  return mapSummaryToHistoricalFields(summary)
}

export function getCountries() {
  return axios.get(`${BASE_FAMOUS_PATH}/countries`)
}
